import { LitElement, html } from "lit-element";
import './ddl-input.js';
import './combobox.js';
import './dynamic-ddl.js';
import './text-box.js';
import './inspx-boolean-field.js';
import './barcode-box.js';
import { OutputField } from './output-field';

export class InspxObjectBase extends LitElement {
	renderField(p) {
		switch (p.renderingType) {
			case 'string':
				return this.renderTextInput(p);
			case 'date-time':
				return this.renderDateInput(p);
			case 'date':
				return this.renderDateInput(p, 'date');
			case 'time':
				return this.renderDateInput(p, 'time');
			case 'multiline':
				return this.renderTextInput(p, 'multiline');
			case 'dropdown':
				return this.renderDdl(p);
			case 'combo':
				return this.renderCombo(p);
			case 'output':
				return this.renderOutput(p);
			case 'integer':
			case 'number':
				return this.renderNumberInput(p);
			case 'fnddl':
				return this.renderDynamicDDL(p);
			case 'group':
				return this.renderGroupInput(p);
			case 'arrayGroup':
				return this.renderArrayGroupInput(p);
			case 'checkbox':
			case 'toggle':
				return this.renderBooleanInput(p);
			case 'barcode':
				return this.renderBarcodeInput(p);
		}
	}


	renderCombo(prop) {
		const path = this.pathprefix + '.' + prop.name;

		return html`<combo-input id="${prop.name}" ?required="${prop.req}" .label="${prop.title}" .value="${this.data[prop.name]}" ?disabled="${prop.readonly || this.disabled}"
    .options="${prop.labels}" .path="${path}" ?isInvalid="${this.isInputInvalid(path)}" .validationMessage="${prop.validationMessage}"></combo-input>`;
	}


	renderDdl(prop) {
		const path = this.pathprefix + '.' + prop.name;

		return html`<ddl-input id="${prop.name}" ?required="${prop.req}" .label="${prop.title}" .value="${this.data[prop.name]}" ?disabled="${prop.readonly || this.disabled}"
    .options="${prop.labels}" .path="${path}" ?isInvalid="${this.isInputInvalid(path)}" .validationMessage="${prop.validationMessage}"></ddl-input>`;
	}

	renderDynamicDDL(prop) {
		const path = this.pathprefix + '.' + prop.name;

		return html`<inspx-fnddl-field id="${prop.name}" .prop="${prop}" .localContext="${this.data}" .value="${this.data[prop.name]}"
    .path="${path}" ?disabled="${prop.readonly || this.disabled}" ?required="${prop.req}" ?isInvalid="${this.isInputInvalid(path)}"
    .validationMessage="${prop.validationMessage}"></inspx-fnddl-field>`;
	}

	renderOutput(prop) {
		const outputField = new OutputField(prop);

		outputField.localContext = this.data;
		return outputField;
	}

	renderDateInput(prop, type = 'datetime-local') {
		const path = this.pathprefix + '.' + prop.name;

		return html`<text-box type="${type}" .label="${prop.title}" .value="${this.data[prop.name]}" ?disabled="${prop.readonly || this.disabled}"
    .path="${path}" ?required="${prop.req}" .min="${prop.formatMinimum}" .max="${prop.formatMaximum}" ?isInvalid="${this.isInputInvalid(path)}"
    .validationMessage="${prop.validationMessage}"></text-box>`;
	}

	renderNumberInput(prop) {
		const path = this.pathprefix + '.' + prop.name;

		return html`<text-box type="number" .label="${prop.title}" .value="${this.data[prop.name]}" .path="${path}" ?required="${prop.req}"
    .min="${prop.minimum}" ?disabled="${prop.readonly || this.disabled}" .max="${prop.maximum}" ?isInvalid="${this.isInputInvalid(path)}"
    .validationMessage="${prop.validationMessage}"></text-box>`;
	}

	renderTextInput(prop, type = 'text') {
		const path = this.pathprefix + '.' + prop.name;

		return html`<text-box type="${type}" .label="${prop.title}" .value="${this.data[prop.name]}" .path="${path}" ?required="${prop.req}"
    ?disabled="${prop.readonly || this.disabled}" .pattern="${prop.pattern}" ?isInvalid="${this.isInputInvalid(path)}"
    .validationMessage="${prop.validationMessage}"></text-box>`;
	}

	renderBooleanInput(prop) {
		return html`<boolean-field type="${prop.checkbox ? 'checkbox' : 'toggle'}" .label="${prop.title}" ?disabled="${prop.readonly || this.disabled}"
    .value="${this.data[prop.name]}" .path="${this.pathprefix + "." + prop.name}"></boolean-field>`;
	}

	renderBarcodeInput(prop) {
		const path = this.pathprefix + '.' + prop.name;

		return html`<barcode-box
			.label="${prop.title}"
			.value="${this.data[prop.name]}"
			.path="${path}"
			.pattern="${prop.pattern}"
			?required="${prop.req}"
    		?disabled="${prop.readonly || this.disabled}"
			?isInvalid="${this.isInputInvalid(path)}"
    		.validationMessage="${prop.validationMessage}"></barcode-box>`;
	}

	isInputInvalid(path) {
		return (this.invalidFields && this.invalidFields.findIndex(f => f.fullPath === path) > -1);
	}

	static get properties() {
		return {
			disabled: { type: Boolean },
			disablePhotos: { type: Boolean },
			data: Object,
			pathprefix: String,
			parts: Array,
			cardtitle: String,
			inspId: String,
			invalidFields: { type: Array },
		};
	}
}
